import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Faq } from '../../shared/types/FaqDto';

@Component({
  selector: 'lp2-faq-list',
  templateUrl: './faq-list.component.html',
  styleUrls: ['./faq-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaqListComponent {
  @Input() faqs: Array<Faq>;
}



// WEBPACK FOOTER //
// ./ts/app/faq/faq-list/faq-list.component.ts